import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadInsertLocationOptions } from '../store/options.actions'

export function* getVadInsertLocationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadInsertLocationOptions])
    const { entity } = response
    yield put(setVadInsertLocationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadInsertLocationOptions() error: ${e}`))
  }
}
export function* getVadInsertLocationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadInsertLocationOptions)
}
